const updateLive = (state = {}, action) => {
  const { type = null, datasource } = action;

  if (type === 'dataEngine_update_response') {
      if (datasource === 'gumbo') {
          const numberOfPlays = action?.data?.liveData?.plays?.allPlays?.length || 0;
          if (numberOfPlays !== state.numberOfPlays) {
              return {
                  ...state,
                  numberOfPlays
              };
          }
      }
  }

  return state;
};

export default updateLive;
